export default [
    "Игрок",
    "Silver VIP",
    "Gold VIP",
    "Platinum VIP",
    "Diamond VIP",
    "Media VIP",
]